<template>
	<div class="common-search">
		<el-input :placeholder="computedPlaceholder" v-model="innerValue" class="search-input" @input="inputSearch" clearable>
			<i slot="suffix" class="iconfont icon-icon_sousuo_16_sousuokuang1" v-if="!innerValue"></i>
		</el-input>
	</div>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { debounce } from '@/utils/api';

const { proxy } = getCurrentInstance();

const props = defineProps({
	value: {
		type: String
	},
	placeholder: {
		type: String,
		default: ''
	}
});
const emits = defineEmits(['update:value', 'change']);
const computedPlaceholder = computed(() => props.placeholder || proxy.$t('enterprise.default-search'));  

const innerValue = computed({
	get: () => props.value,
	set: val => {
		emits('update:value', val);
	}
});
const inputSearch = debounce(function (val) {
	emits('change', val);
}, 200);
</script>

<style lang="less" scoped>
.common-search {
	.search-input {
		width: 232px;

		.iconfont {
			font-size: 16px;
			color: #4e5969;
		}
	}
	/deep/.el-input__suffix {
		right: 0;
		width: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
